module.exports = function getResource(label, vars = []) {
    const resources = {
        title: 'Sauter l’article',
        mainHeader: 'Êtes-vous sûr de vouloir sauter votre prochaine commande? Votre abonnement reprendra automatiquement la livraison le',
        skip: 'Passer',
        cancel: 'Annuler',
        item: 'ARTICLE',
        qty: 'Qté',
        notRated: 'Aucune note',
        oneReview: 'Un commentaire',
        yearlySavings: 'économies annuelles',
        nextShipmentBy: 'Prochaine livraison le'
    };

    return resources[label];
};
